export const BAND_KEY_ORDER = [
  'above_plan',
  'on_plan',
  'medium_risk',
  'at_risk',
] as const;

export type BandKey = (typeof BAND_KEY_ORDER)[number];

/** Mirrors RagProfile::BAND_LABEL_MAX_LENGTH. */
export const BAND_LABEL_MAX_LENGTH = 40;

export const SHIPPED_BEST_POSSIBLE_NAME = 'Best Possible';
export const SHIPPED_COMMITTED_NAME = 'Committed';

export interface RagBand {
  key: BandKey;
  enabled: number;
  threshold: number | null;
}

export interface RagProfile {
  id: number;
  key?: string;
  name: string;
  basis: 'gap' | 'legacy';
  isLocked: boolean;
  isDefault?: boolean;
  bands: RagBand[];
  inUse: boolean;
  updateAt?: number;
}

export interface RagProfilesPayload {
  profiles: RagProfile[];
  assignments: { basic?: number; committed?: number };
  bandColors: Record<BandKey, string>;
  bandLabels: Record<BandKey, string>;
  defaultBandLabels: Record<BandKey, string>;
  defaultBands: RagBand[];
  defaultCommittedBands: RagBand[];
  defaultBandColors: Record<BandKey, string>;
  newRagEnabled: boolean;
  canEdit: boolean;
}

export interface EditingProfile {
  id: number | null;
  name: string;
  basis: 'gap' | 'legacy';
  isLocked: boolean;
  isDefault?: boolean;
  bands: RagBand[];
}
